module.exports = __webpack_public_path__ + "img/slide1-bg-150x150.8b1658f7.jpg";